import React from 'react';
import Container from 'container';
import Icon from 'icon';
import Headline from 'headline';
import s from './big_icon_cards.module.scss';

export default function AdA({ headline, cards, ...props }) {
  return (
    <Container className={s.root}>
      <Headline className={s.headline} center html={headline} />
      <div className={s.cardsWrapper}>
        {cards.map(({ icon, title, text }, i) => (
          <div key={title} className={`${s.cardWrapper} ${(i + 1) === cards.length && s.lastCard}`}>
            <div className={s.iconWrapper}>
              <Icon className={`${s.icon} ${(i % 2 === 0) && s.marginBottom}`} icon={icon} />
            </div>
            <Headline className={s.title} center html={title} />
            <p className={s.text} dangerouslySetInnerHTML={{ __html: text }} />
          </div>
      ))}
      </div>
    </Container>
  );
}


